import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

import type { ITablePageNumberProps } from "@components/organisms/pageTable";
import { Typography } from "@components/atoms/typography";

const getCount = (page: number, perPage: number, total: number) => {
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  return `${start} - ${end}`;
};

export function TablePageNumber({
  page,
  perPage,
  total,
}: ITablePageNumberProps) {
  const { t } = useTranslation("common");

  const count = useMemo(() => {
    return getCount(page, perPage, total);
  }, [page, perPage, total]);

  return (
    <div className={styles.container}>
      <Typography>
        {t("table_page_number", { number_text: count, total })}
      </Typography>
    </div>
  );
}
